export default "__VITE_ASSET__ba41762c__"